export const ICONS_5 = [
  "16-ai-action-white",
  "16-calendar-event",
  "16-bubble-wide-annotation-feedback",
  "16-people-added-new-member",
  "16-clock-alert-trial",
  "16-bubble-alert-payment",
  "16-gift",
  "16-shuffle-target-member",
  "16-star-lines-celebrate",
  "16-siren-re-engage",
  "16-bubbles-message",
  "16-calendar-clock-event",
  "16-heart-beat-engagement",
  "16-trending-circle-boost",
  "16-clipboard-feedback",
  "16-bubble-heart",
  "16-group-member",
  "16-tag-comment",
  "16-people-add-bulk",
  "16-square-behind-square-clone",
  "16-people-remove",
  "16-raising-hand-greet",
  "16-page-check-form",
  "16-target-arrow-tag",
  "16-credit-card",
  "16-hourglass",
  "16-coin-dollar",
  "16-thumbs-up-2",
  "16-trophy",
  "16-fork-code",
  "16-page-check",
  "16-rejected-comment",
  "16-square-arrow-top-right",
  "16-settings-gear",
  "20-user-add",
  "20-ai-filter",
  "12-ai-filter",
  "20-open-quote",
];
